import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: 'input[appNumericOnlyFive][type="number"]'
})
export class NumericOnlyFive {
  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove special characters including "-", ".", and consecutive dashes "--"
    value = value.replace(/[^\d]/g, ''); // Remove any non-digit character

    if (/^0/.test(value)) {
      input.value = ""; // Clear the input if it starts with zero
    } else if (value.length > 5) {
      input.value = value.slice(0, 5); // Limit to 5 digits
    } else {
      input.value = value; // Otherwise, keep the modified value
    }
  }
}
